import { ConfigViewer } from "@/features/admin/config-viewer";

export default function AdminConfigViewerPage() {
  return <ConfigViewer />;
}
